export default {
  frame: {
    list_title: 'Notice List',
    list_tag_top: 'Top',
    list_tag_emergency: 'Emergency',
    list_tag_important: 'Important',
    sysInform: 'System Informs',
    loadingMore: 'Loading more ...',
    doc: 'Detail docs',
    warning: 'The server is busy, please try again later ...',
    top: 'Top',
    expiryDate: 'Expiry Date',
    to: 'to',
    relatedFiles: 'Related Files',
    home: 'Home',
    list: 'Notice List',
    title: 'Notice List',
    listDetail: 'Notice Detail',
    systemInfo: 'System Info',
    systemInfoContent: 'Your token is invalid, please try login again',
    pagerFooter: 'China Mobile International Limited. All rights reserved.',
    changeTitle: 'Change Password',
    personalTitle: 'Personal Information',
    mySettings: 'My Settings',

    firstName: 'Firs tName',
    lastName: 'Last Name',
    alias: 'Alias',
    email: 'Email',
    staffNO: 'StaffNO',
    nickname: 'Nickname',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    department: 'Department',
    countryRegion: 'Country/Region',
    stateProvince: 'State/Province',
    city: 'City',
    postCode: 'PostCode',
    streetAddress: 'Street Address',
    currency: 'Currency',
    cancel: 'Cancel',

    HKD: 'Hong Kong Dollar',
    USD: 'U.S. Dollar',
    EUR: 'Euro',
    SGD: 'Singapore Dollar',
    GBP: 'British Pound',
    CNY: 'Chinese Yuan',

    accountId: 'Account Id',
    oldPsd: 'Old Password',
    newPsd: 'New Password',
    confirmNew: 'Confirm New',
    mobileNum: 'Mobile Number',
    psdRule: 'Password Rules',
    rule1: 'The length of new password must be more than seven',
    rule2: 'asswords must contain three of the four following types of characters:',
    rule3: 'Upper case letters from A to Z',
    rule4: 'case letters from a to z',
    rule5: 'numbers from 0 to 9',
    rule6: 'password is effectively in 90 days',
    rule7: 'New password must not be used in last five times',
    rule8: 'Non-alphanumeric characters (special chars)',
    submit: 'Submit',
    check: 'New password is not consistent with the confirmed password',
    inputNull: 'Cannot be empty',
    btn_yes: 'OK',
    change_psd: 'Change Password',
    emailError: 'Format error',
    mobileError: 'Please input using the format：(+CountryCode)Number, eg.(+86)13112345678',
  },
  message: {
    modify_success: 'Modify the success',
    modify_fail: 'Modify the failure',
    save_success: 'Save success',
    save_fail: 'Save failed',
    del_success: 'Delete the success',
    del_partner_sure: 'Are you sure you want to delete this partner？',
    del_chl_sure: 'Are you sure you want to delete this channel information？'
  },
  promotion: {
    cancel: 'Cancel',
    ok: 'OK'
  },

  notice_local: {
    notice: {
      one_select: 'You can only manipulate one piece of data',
      create_success: 'New Bulletin Success',
      create_erromessge: 'New Bulletin Fail',
      update_success: 'Update Bulletin Success',
      update_erromessge: 'Update Bulletin Fail',
      logout_success: 'Successful Logout',
      logout_fail: 'The Logout Is Not Successful',
      verify_time: 'The Effective Time Must Be Less Than The Failure Time',
      logout_erromessge: 'The Logout Operation Cannot Be Performed',
      update_erromessge: 'Unable To Modify Operation',
      qry_erromessge: 'Query Operation Failed',
      logout_erromessge_select: 'Please Select Operation Information.',
      title: 'home',
      sub_title: 'System Management ',
      main_title: 'Notice Management',
      query_title: 'Title',
      query_state: 'State',
      query_effective: 'Effective Day',
      query_expiry: 'Expiry Day',
      query_btn: 'Query',
      query_new: 'New',
      tab_id: 'Notice ID',
      tab_title: 'Title',
      logout_btn: 'LogOut',
      tab_level: 'Notice Level',
      tab_range: 'Publish Range',
      tab_state: 'State',
      tab_effective: 'Effective Day',
      tab_expiry: 'Expiry Day',
      tab_creat: 'Creation Day',
      tab_operation: 'Operation',
      tab_modify: 'Modify',
      tab_detail: 'Detail',
      tab_delete: 'Delete',
      pop_role_search: 'Search',
      pop_role_title: '角色选择',
      pop_role_code: 'Role Code',
      pop_role_name: 'Role Name',
      pop_ok: 'OK',
      pop_notice: '公告信息',
      pop_notice_state: 'Display State',
      pop_notice_content: 'Content',
      pop_notice_stick: 'Stick Top',
      pop_notice_unit: 'Publish Unit',
      pop_notice_role: 'Publish Role',
      pop_submit: 'Submit',
      pop_modify_title: 'Modify Notice ',
      list_title: 'Notice List',
      list_tag_top: 'Top',
      list_tag_emergency: 'Emergency',
      list_tag_important: 'Important'
    }
  },
  my_task: {
    myTasks: 'My Tasks',
    dueDate: 'Due Date',
    status: 'Status',
    subject: 'Subject',
    name: 'Name',
    relatedTo: 'Related To',
    account: 'Account',
    oper: 'Oper',
    newTask: 'New Task',
    complete: 'Complete',
    modify: 'Modify',
    detail: 'Detail',
    taskListFilter: 'Task list filter:',
    submitSuccess: 'Submitted Successfully!',
    taskDetail: 'Task Detail',
    newTaskAdd: {
      newTasks: 'New Task',
      recordType: 'Record Type',
      subject: 'Subject',
      assignedTo: 'Assigned To',
      name: 'Name',
      activityCurrency: 'Activity Currency',
      comments: 'Comments',
      priority: 'Priority',
      createRecurrTasks: 'Create Recurring Series of Tasks',
      attachments: 'Attachments',
      upload: 'Upload',
      submit: 'Submit',
      select: 'select',
      dueDate: 'Due Date',
      relatedTo: 'Related To',
      status: 'Status',
      cancel: 'Cancel',
      notEmpty: 'can not be empty',
      modifyTask: 'Modify Task',
      modifySeris: 'Modify Series',
      cancelReturn: 'Return'
    },
    staff: {
      staffInfo: 'Select the assigned person',
      staffNo: 'Staff No',
      staffName: 'Staff Name',
      departName: 'depart Name',
      contactTel: 'contact Tel',
      search: 'Search'
    },
    contact: {
      contactInfo: 'Select Contacts',
      contactType: 'Contact Type',
      contactName: 'Contact Name',
      contactEmail: 'Mailbox',
      contactTel: 'Telephone Number',
      contactTitle: 'Title',
      contactCountry: 'Country/Area'
    },
    campaign: {
      campaignInfo: 'Select Campaign',
      campaignName: 'Campaign Name',
      startDate: 'Start Date',
      status: 'Status',
      updatedTime: 'Updated Time'
    },
    opportunity: {
      opportunityInfo: 'Select Opportunity',
      opportunity_name: 'Opportunity Name',
      customer_name: 'Customer Name',
      close_date: 'Close Date',
      stage: 'Stage',
      owner: 'Owner',
      created_time: 'Created Time'
    },
    leads: {
      leadsInfo: 'select Lead',
      company: 'Company',
      owner: 'Owner',
      leadStatus: 'Lead Status',
      leadSource: 'Lead Source',
      leadCurrency: 'Lead Currency',
      creator: 'Creator',
      creatorDate: 'Created Date'
    },
    cust: {
      custInfo: 'Select Cust',
      customer_name: 'Cust Name',
      inter_account_manage: 'Internet Customer Manager',
      voice_account_manage: 'Voice Customer Manager',
      mobile_account_manage: 'Mobile Customer Manager'
    },
    subjectSelect: {
      selectSubjectInfo: 'Select a Subject below.'
    }
  },
  handle_local: {
    handle: {
      order_title: 'order title',
      applicant: 'applicant Number',
      applicant_name: 'applicant',
      application_date: 'application date',
      query_btn: 'query',
      application_form_title: 'order title',
      operation: 'operation',
      unHandle: 'Todo',
      handle: 'Processed'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locals/en-US.js